import { render } from "./SectionTechFront.vue?vue&type=template&id=059be9b8&scoped=true"
import script from "./SectionTechFront.vue?vue&type=script&lang=js"
export * from "./SectionTechFront.vue?vue&type=script&lang=js"

import "./SectionTechFront.vue?vue&type=style&index=0&id=059be9b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059be9b8"]])

export default __exports__